var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMarkAsFavorite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1846 13.5025V16.1822H19.8644V17.9687H17.1837L17.1846 20.6484H15.3981L15.3972 17.9687H12.7184V16.1822H15.3981V13.5025H17.1846ZM18.2949 5.24617C20.3154 7.27206 20.3851 10.4985 18.5057 12.6021L17.2373 11.3355C18.4262 9.97414 18.3637 7.83927 17.0301 6.50833C15.6875 5.16935 13.5286 5.11219 12.1262 6.37166L10.9337 7.44177L9.74031 6.37256C8.33344 5.11129 6.17536 5.16667 4.83281 6.51012C3.50187 7.84105 3.43488 9.97146 4.66131 11.3792L12.1932 18.9236L10.9319 20.1884L3.35717 12.603C1.47778 10.4985 1.54834 7.2667 3.56797 5.24617C5.59118 3.22386 8.82741 3.15598 10.9319 5.04251C13.0301 3.15866 16.2726 3.22118 18.294 5.24617H18.2949Z",
    fill: "#848484"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkAsFavorite);
export default __webpack_public_path__ + "static/media/mark-as-favorite.5f809e5abfcecc26b803c4c12ebac88c.svg";
export { ForwardRef as ReactComponent };